import React from 'react';
import { compose } from 'ramda';
import { Slider as CoreSlider } from '@core/js/components/common/Slider';
import { withDynamicReducer } from '@core/js/components/common/Slider/store';

export const Slider = (props) => <CoreSlider showDisabledArrows={true} { ...props}/>;

export default compose(
    withDynamicReducer()
)(Slider);
